import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function getSessionId(): string {
  const key = "sv_session_id";
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(key, id);
  }
  return id;
}

export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;
    // Don't track admin pages or duplicate consecutive views
    if (path.startsWith("/admin") || path === lastPath.current) return;
    lastPath.current = path;

    const sessionId = getSessionId();

    // Fire and forget — non-blocking
    fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/track-pageview`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      },
      body: JSON.stringify({
        path,
        referrer: document.referrer || null,
        session_id: sessionId,
      }),
    }).catch(() => {
      // Silently fail — analytics should never break UX
    });
  }, [location.pathname]);
}
